 <template>
<div>
  <base-header type="gradient-success" class="pb-6">
  </base-header>
  <create-and-show></create-and-show>
  <categoria></categoria>
  <Notification></Notification>
  <update-index></update-index>
</div>
</template>

<script>
import CreateAndShow from "@/components/Configuration/CreateAndShow";
import Categoria from "@/components/Configuration/Categoria";
import Notification from "@/components/Configuration/Notification";
import UpdateIndex from "@/components/Configuration/UpdateIndex";
export default {
name: "index",
  components: {UpdateIndex, Notification, Categoria, CreateAndShow}
}
</script>

<style scoped>

</style>